import { supabase } from "..";

export const getsaveddream = (email) => {
  return supabase
    .from("save_dream_while_sleeping")
    .select()
    .eq("email", email)
    .order("id", { ascending: true });
};
export const deletesaveddream = (id) => {
  supabase
    .from("save_dream_while_sleeping")
    .delete()
    .eq("id", id)
    .then((res) => {});
};

export const createDream = (obj) => {
  return supabase
    .from("DreamsData")
    .insert([{ email: obj.email, dream: obj.dream, journalDate: obj["date"] }])
    .select();
};
export const createUser = (formData) => {
  return supabase.from("subs_users").insert(formData);
};
